import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const key = () => ['historyAddress'];

const fetchHistory = async ({ flatId }) => {
  const res = await request.get(
    `/FlatsGrid/history_change_address_life_cycle/${flatId}`,
    null,
    'Не удалось загрузить историю помещения'
  );
  return res;
};

const useHistoryQuery = (params = {}, options) => {
  const query = useQuery(key(), () => fetchHistory(params), options);
  return {
    data: query.data,
    loading: query.isLoading
  }
}

export { useHistoryQuery }
